import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const statusBadgeVariants = cva(
  "inline-flex items-center font-bold whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        neutral: "bg-muted-foreground/90 text-white ring-muted-foreground/20",
        success: "bg-success/90 text-success-foreground ring-success/20",
        warning: "bg-warning/90 text-warning-foreground ring-warning/20",
        danger: "bg-destructive/90 text-destructive-foreground ring-destructive/20",
        info: "bg-info/90 text-info-foreground ring-info/20",
        orange: "bg-warning/90 text-warning-foreground ring-warning/20",
        violet: "bg-violet-600/90 text-white ring-violet-500/20",
        primary: "bg-primary/90 text-primary-foreground ring-primary/20",
      },
      size: {
        sm: "rounded-full px-2.5 py-0.5 text-[10px] uppercase tracking-wide",
        md: "rounded-full px-3 py-1.5 text-xs",
        lg: "rounded-full px-3 py-1.5 text-sm",
      },
      appearance: {
        solid: "border",
        overlay:
          "rounded-full backdrop-blur-md text-white shadow-lg ring-1 ring-inset ring-white/20",
        outline: "rounded-full border bg-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      appearance: "solid",
    },
  }
)

export type StatusBadgeVariant = NonNullable<
  VariantProps<typeof statusBadgeVariants>["variant"]
>

export interface StatusBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusBadgeVariants> {}

export function StatusBadge({
  className,
  variant,
  size,
  appearance,
  ...props
}: StatusBadgeProps) {
  return (
    <span
      className={cn(statusBadgeVariants({ variant, size, appearance }), className)}
      {...props}
    />
  )
}

export { statusBadgeVariants }
